import React from 'react'

import InstantValuationArticleBanner from '~/components/atoms/InstantValuationArticleBanner/InstantValuationArticleBanner'
import Advert from '~/components/blocks/MagazineAdvert/Advert'
import type { ReportCardProps } from '~/components/blocks/ReportCard/ReportCard'
import ReportCard from '~/components/blocks/ReportCard/ReportCard'
import { useAuthV2 } from '~/contexts/AuthContext'

import ArtistArticleCard from './ArticleStickyBanners/ArtistArticleCard'
import MarketReportsCard from './ArticleStickyBanners/MarketReportsCard'
import SignUpCard from './ArticleStickyBanners/SignUpCard'

const buyRegex = /buyer['']?s guide/i
const sellRegex = /seller['']?s guide/i
const valuationRegex = /valuation guide/i

interface DesktopStickyAdvertProps {
  advert?: any
  featuredReport?: ReportCardProps | null
  artistName?: string
  artistSlug?: string
  articleTitle?: string
  isValuationsOldBannerAd: boolean
  onValuationClick?: () => void
}

const DesktopStickyAdvert = ({
  advert,
  featuredReport,
  artistName,
  artistSlug,
  articleTitle,
  isValuationsOldBannerAd,
  onValuationClick,
}: DesktopStickyAdvertProps) => {
  const { user } = useAuthV2()
  const isBuyersGuide = articleTitle ? buyRegex.test(articleTitle) : false
  const isSellersGuide = articleTitle ? sellRegex.test(articleTitle) : false
  const isValuationGuide = articleTitle
    ? valuationRegex.test(articleTitle)
    : false
  const isArtistArticleCard = Boolean(
    artistName &&
    artistSlug &&
    /series|série|10 facts|10 faits/i.test(articleTitle ?? '')
  )

  if (
    isValuationsOldBannerAd &&
    !featuredReport &&
    !isBuyersGuide &&
    !isSellersGuide &&
    !isValuationGuide &&
    !isArtistArticleCard &&
    !!user
  ) {
    return null
  }

  if (isBuyersGuide) {
    return featuredReport ? (
      <ReportCard
        {...featuredReport}
        variant="featurePanel"
        matchGridHeight={false}
      />
    ) : (
      <MarketReportsCard />
    )
  }

  if (isSellersGuide || isValuationGuide) {
    return (
      <InstantValuationArticleBanner
        artistName={artistName}
        onValuationClick={onValuationClick}
      />
    )
  }

  if (featuredReport) {
    return (
      <ReportCard
        {...featuredReport}
        variant="featurePanel"
        matchGridHeight={false}
      />
    )
  }

  if (isArtistArticleCard) {
    return (
      <ArtistArticleCard artistName={artistName!} artistSlug={artistSlug!} />
    )
  }

  if (!user) {
    return <SignUpCard />
  }

  if (!advert?.image) {
    return (
      <InstantValuationArticleBanner
        artistName={artistName}
        onValuationClick={onValuationClick}
      />
    )
  }

  return <Advert {...advert} />
}

export default DesktopStickyAdvert
